/**

procapz-cart.js

═══════════════════════════════════════════════════════════════

Sistema de cart drawer independente.

Não depende de nenhum código do tema.

═══════════════════════════════════════════════════════════════*/
(function () {
'use strict';

/* ─────────────────────────────────────────────────────────────
UTILS
───────────────────────────────────────────────────────────── */

function $(sel, ctx) { return (ctx || document).querySelector(sel); }
function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

function parseJsonResponse(r) {
  return r.json().then(function (data) {
    if (!r.ok) {
      var message = (data && (data.description || data.message)) || 'Erro na requisição do carrinho';
      var err = new Error(message);
      err.status = r.status;
      err.payload = data;
      throw err;
    }
    return data;
  });
}

function fetchCart() {
  return fetch('/cart.js?_=' + Date.now(), {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
  }).then(parseJsonResponse);
}

function wait(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }

function cartChange(lineOrKey, qty) {
  var body = typeof lineOrKey === 'string' && lineOrKey.indexOf(':') >= 0
    ? JSON.stringify({ id: lineOrKey, quantity: qty })
    : JSON.stringify({ line: lineOrKey, quantity: Math.max(0, parseInt(qty, 10) || 0) });

  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: body
  }).then(parseJsonResponse);
}

function cartAdd(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ items: items })
  }).then(parseJsonResponse);
}

function cartUpdate(updates) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ updates: updates })
  }).then(parseJsonResponse);
}

function cartUpdateDiscount(discountCode) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ discount: discountCode || '' })
  }).then(parseJsonResponse);
}

function moneyBRL(cents) {
  return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
}

function debounce(fn, delay) {
  var timer;
  return function () {
    var args = arguments;
    var ctx = this;
    clearTimeout(timer);
    timer = setTimeout(function () { fn.apply(ctx, args); }, delay);
  };
}

function normalizeDiscountMode(mode) {
  mode = String(mode || '').trim().toLowerCase();
  if (mode === 'free') return 'free';
  if (mode === 'percent') return 'percent';
  return '';
}

function parseDiscountValue(value) {
  var num = Number(value);
  if (!isFinite(num) || num < 0) return 0;
  return num;
}

function parseMoneyPropertyValue(value) {
  if (value == null || value === '') return 0;
  var normalized = String(value).replace(/[^\d.-]/g, '');
  var num = Number(normalized);
  if (!isFinite(num) || num <= 0) return 0;
  return Math.round(num);
}

/* ─────────────────────────────────────────────────────────────
BLOCKED LINK HELPER
───────────────────────────────────────────────────────────── */

/**
 * Lê o atributo data-blocked-product-ids do drawer e retorna
 * um Set com os IDs (como string) dos produtos cujo link
 * deve ser suprimido no carrinho.
 */
function getBlockedProductIds() {
  var drawer = document.querySelector('#PcozCartDrawer');
  if (!drawer) return new Set();

  var raw = (drawer.dataset.blockedProductIds || '').trim();
  if (!raw) return new Set();

  return new Set(
    raw.split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
  );
}

/* ─────────────────────────────────────────────────────────────
EXCLUSION HELPER
───────────────────────────────────────────────────────────── */

function normalizePromoId(value) {
  value = String(value == null ? '' : value).trim();
  if (!value) return '';
  var numeric = value.match(/(\d+)$/);
  return numeric ? numeric[1] : value;
}

function parseIdList(str) {
  if (!str || !String(str).trim()) return [];
  var list = String(str)
    .split(',')
    .map(function (s) { return normalizePromoId(s); })
    .filter(Boolean);
  return list.filter(function (value, index, arr) { return arr.indexOf(value) === index; });
}

function getItemProductId(item) {
  return normalizePromoId(item && (item.product_id || item.productId || item.product_id_str));
}

function getItemVariantId(item) {
  return normalizePromoId(item && (item.variant_id || item.id));
}

function markerIncludedProducts(marker) {
  return parseIdList(marker && marker.dataset ? marker.dataset.includedProducts || '' : '');
}

function getPromoMarkersFromDom() {
  var drawer = document.querySelector('#PcozCartDrawer');
  var bar = drawer ? drawer.querySelector('#PcozCartPromoBar') : document.querySelector('#PcozCartPromoBar');
  if (!bar) return [];
  return Array.from(bar.querySelectorAll('[data-pcz-marker]'));
}

function getEffectiveIncludedProductsForMarker(marker) {
  var direct = markerIncludedProducts(marker);
  if (direct.length) return direct;

  if (!marker || !marker.dataset) return [];
  if (marker.dataset.promoType !== 'percent_discount') return [];
  if (marker.dataset.triggerType !== 'same_product_qty') return [];

  var inherited = [];
  getPromoMarkersFromDom().forEach(function (other) {
    if (!other || other === marker || !other.dataset) return;
    if (other.dataset.promoType !== 'percent_discount') return;
    if (other.dataset.triggerType !== 'same_product_qty') return;

    markerIncludedProducts(other).forEach(function (id) {
      if (id && inherited.indexOf(id) === -1) inherited.push(id);
    });
  });

  return inherited;
}

function markerHasIncludedProducts(marker) {
  return getEffectiveIncludedProductsForMarker(marker).length > 0;
}

function isItemIncludedInPromo(item, marker) {
  if (!item || !marker) return false;
  var includedProducts = getEffectiveIncludedProductsForMarker(marker);
  if (!includedProducts.length) return false;
  var productId = getItemProductId(item);
  var variantId = getItemVariantId(item);
  return (productId && includedProducts.indexOf(productId) !== -1) ||
    (variantId && includedProducts.indexOf(variantId) !== -1);
}

function isGiftExcludedItem(item, marker) {
  return !isItemIncludedInPromo(item, marker);
}

function isDiscountExcludedItem(item, marker) {
  return !isItemIncludedInPromo(item, marker);
}

function isItemExcludedFromMarkers(item, markers) {
  if (!markers || !markers.length) return false;
  return markers.some(function (marker) { return isGiftExcludedItem(item, marker); });
}

function getNonGiftItems(cart) {
  return (cart.items || []).filter(function (item) {
    return !(item.properties && item.properties['_promo_gift'] === 'true');
  });
}

function getGiftEligibleItems(cart, marker) {
  return getNonGiftItems(cart).filter(function (item) {
    return !isGiftExcludedItem(item, marker);
  });
}

function buildMetricsFromItems(items) {
  var qtyMap = {};
  var itemCount = 0;
  var subtotal = 0;

  (items || []).forEach(function (item) {
    qtyMap[item.product_id] = (qtyMap[item.product_id] || 0) + item.quantity;
    itemCount += item.quantity || 0;
    subtotal += Number(
      item.original_line_price != null ? item.original_line_price : item.final_line_price
    ) || 0;
  });

  var qtyValues = Object.values(qtyMap);
  var maxQty = qtyValues.length ? Math.max.apply(null, qtyValues) : 0;

  return {
    items: items || [],
    itemCount: itemCount,
    subtotal: subtotal,
    maxQty: maxQty,
    hasEligibleItems: !!((items || []).length)
  };
}

function getGiftEligibleMetrics(cart, marker) {
  return buildMetricsFromItems(getGiftEligibleItems(cart, marker));
}

function getDiscountEligibleItemsForMarker(cart, marker) {
  return getNonGiftItems(cart).filter(function (item) {
    return !isDiscountExcludedItem(item, marker);
  });
}

function getDiscountEligibleMetricsForMarker(cart, marker) {
  return buildMetricsFromItems(getDiscountEligibleItemsForMarker(cart, marker));
}

function getDiscountEligibleItems(cart, giftMarkers) {
  return getNonGiftItems(cart).filter(function (item) {
    return !isItemExcludedFromMarkers(item, giftMarkers);
  });
}

function getDiscountEligibleMetrics(cart, giftMarkers) {
  return buildMetricsFromItems(getDiscountEligibleItems(cart, giftMarkers));
}

function cartQualifiesForGift(cart, marker) {
  return getGiftEligibleMetrics(cart, marker).hasEligibleItems;
}

/*
  Quantidade de brindes que o carrinho merece.
  Sem "repetir": sempre 1. Com "repetir": 1 brinde a cada múltiplo do gatilho
  (ex.: gatilho 1 + 2 kits = 2 brindes), limitado por data-gift-max (0 = sem limite).
*/
function getGiftTargetQty(cart, marker) {
  if (!marker || !marker.dataset || marker.dataset.giftRepeat !== 'true') return 1;

  var threshold = Number(marker.dataset.threshold || 0);
  if (!(threshold > 0)) return 1;

  var metrics = getGiftEligibleMetrics(cart, marker);
  var tt = marker.dataset.triggerType;
  var times = 0;

  if (tt === 'same_product_qty') {
    var perProduct = {};
    metrics.items.forEach(function (item) {
      perProduct[item.product_id] = (perProduct[item.product_id] || 0) + (item.quantity || 0);
    });
    Object.keys(perProduct).forEach(function (pid) {
      times += Math.floor(perProduct[pid] / threshold);
    });
  } else if (tt === 'item_count') {
    times = Math.floor(metrics.itemCount / threshold);
  } else if (tt === 'subtotal') {
    times = Math.floor(metrics.subtotal / threshold);
  }

  var max = parseInt(marker.dataset.giftMax, 10) || 0;
  if (max > 0) times = Math.min(times, max);

  return Math.max(1, times);
}

/* ─────────────────────────────────────────────────────────────
CART STATE
───────────────────────────────────────────────────────────── */

var CartState = {
  cart: null,
  isLoading: false,

  load: function () {
    return fetchCart().then(function (c) {
      CartState.cart = c;
      return c;
    });
  }
};

/* ─────────────────────────────────────────────────────────────
DRAWER
───────────────────────────────────────────────────────────── */

var Drawer = {
  drawer: null,
  overlay: null,
  isOpen: false,
  observer: null,
  _delegatedCartTriggerBound: false,

  init: function () {
    this.drawer = $('#PcozCartDrawer');
    this.overlay = $('#PcozCartOverlay');
    if (!this.drawer) return;

    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && Drawer.isOpen) Drawer.close();
    });

    var closeBtn = $('#PcozCartClose');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    this.bindTriggers();
    this.watchHeaderChanges();
  },

  bindTriggers: function () {
    var selectors = [
      '[data-cart-drawer-trigger]',
      '.pcz-header__cart-link',
      '.pcz-header__mobile-cart',
      'a[href="/cart"]',
      'button[data-cart-drawer-trigger]',
      '.header__icon--cart',
      '.cart-icon',
      '.site-header__cart',
      '.header-cart',
      '.header__heading-link[href="/cart"]',
      '.header__icon[href="/cart"]'
    ].join(', ');

    $$(selectors).forEach(function (el) {
      if (el._pcz_bound) return;
      el._pcz_bound = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        Drawer.open();
      }, true);
    });

    if (!this._delegatedCartTriggerBound) {
      this._delegatedCartTriggerBound = true;

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest(
          '[data-cart-drawer-trigger], .pcz-header__cart-link, .pcz-header__mobile-cart, a[href="/cart"], .header__icon--cart, .cart-icon, .site-header__cart, .header-cart, .header__heading-link[href="/cart"], .header__icon[href="/cart"]'
        );

        if (!trigger) return;
        if (trigger.closest('#PcozCartDrawer')) return;

        e.preventDefault();
        e.stopPropagation();
        Drawer.open();
      }, true);
    }
  },

  neutralizeThemeDrawer: function () {
    var themeDrawer = document.querySelector('cart-drawer');
    if (!themeDrawer) return;

    themeDrawer.open = function () { Drawer.open(); };

    var overlay = themeDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      var fresh = overlay.cloneNode(true);
      overlay.parentNode.replaceChild(fresh, overlay);
    }
  },

  watchHeaderChanges: function () {
    if (this.observer) return;

    this.observer = new MutationObserver(function () {
      Drawer.bindTriggers();
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  },

  rebindTriggers: function () {
    this.bindTriggers();
  },

  open: function () {
    if (!this.drawer) return;

    this.isOpen = true;
    this.drawer.classList.add('is-open');

    if (this.overlay) {
      this.overlay.classList.add('is-open');
      this.overlay.setAttribute('aria-hidden', 'false');
    }

    document.body.style.overflow = 'hidden';

    CartState.load().then(function (cart) {
      CartRenderer.render(cart);
      CartRenderer.updateBadge(cart.item_count);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          PromoBar.evaluate(cart);
        });
      });
    }).catch(function (err) {
      console.error('[PcozCart] Falha ao abrir carrinho:', err);
    });
  },

  close: function () {
    if (!this.drawer) return;

    this.isOpen = false;
    this.drawer.classList.remove('is-open');

    if (this.overlay) {
      this.overlay.classList.remove('is-open');
      this.overlay.setAttribute('aria-hidden', 'true');
    }

    document.body.style.overflow = '';
  }
};

/* ─────────────────────────────────────────────────────────────
CART RENDERER
───────────────────────────────────────────────────────────── */

var CartRenderer = {
  setLoading: function (state) {
    var items = $('#PcozCartItems');
    if (items) items.classList.toggle('pcz-cart__items-loading', state);
  },

  render: function (cart) {
    this.renderItems(cart);
    this.renderTotal(cart);
    this.updateEmpty(cart);
    this.updateBadge(cart.item_count);
    this.updateFreeShippingBanner(cart);
    this.updateShippingProgress(cart);
    PromoBar.evaluate(cart);
    UpsellModule.evaluate(cart);
  },

  renderSilent: function (cart) {
    this.renderItems(cart);
    this.renderTotal(cart);
    this.updateEmpty(cart);
    this.updateBadge(cart.item_count);
    this.updateFreeShippingBanner(cart);
    this.updateShippingProgress(cart);
  },

  renderItems: function (cart) {
    var container = $('#PcozCartItems');
    if (!container) return;

    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = '';
      return;
    }

    /* ── IDs dos produtos com link bloqueado ── */
    var blockedIds = getBlockedProductIds();

    container.innerHTML = cart.items.map(function (item, idx) {
      var isGift = item.properties && item.properties['_promo_gift'] === 'true';
      var isUpsell = item.properties && item.properties['_upsell'] === 'true';
      var isLocked = isGift || isUpsell;
      var itemKey = item.key || (idx + 1);
      var line = idx + 1;

      /* ── Verifica se o link do produto deve ser bloqueado ── */
      var productIdStr = String(item.product_id || '');
      var isLinkBlocked = blockedIds.size > 0 && blockedIds.has(productIdStr);

      var variantInfo = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantInfo = '<span class="pcz-cart__item-variant">' + item.variant_title + '</span>';
      }

      var discountBadge = '';

      var qty = Number(item.quantity || 0);
      var finalLinePrice = Number(item.final_line_price || 0);
      var finalUnitPrice = Number(item.final_price || item.price || 0);

      var compareAtUnit = Number(item.compare_at_price || 0);
      var compareLineFromShopify = compareAtUnit > 0 && qty > 0 ? compareAtUnit * qty : 0;

      var comparePriceProp = 0;
      if (item.properties && item.properties._product_compare_price != null) {
        comparePriceProp = parseMoneyPropertyValue(item.properties._product_compare_price);
      }
      var compareLineFromProperty = comparePriceProp > 0 && qty > 0 ? comparePriceProp * qty : 0;

      var compareLineFromCart = Number(item.original_line_price || 0);

      var oldPriceToShow = 0;
      var candidates = [compareLineFromShopify, compareLineFromProperty, compareLineFromCart];
      candidates.forEach(function (c) {
        if (c > finalLinePrice && c > oldPriceToShow) oldPriceToShow = c;
      });

      var productDiscountTag = (function () {
        var isGift = item.properties && item.properties['_promo_gift'] === 'true';
        var isUpsell = item.properties && item.properties['_upsell'] === 'true';
        if (isGift || isUpsell) return '';

        var propertyPercent = 0;
        if (item.properties && item.properties._product_compare_discount != null) {
          propertyPercent = parseInt(item.properties._product_compare_discount, 10) || 0;
        }
        if (propertyPercent > 0) {
          return '<span class="pcz-cart__promo-next-tag pcz-cart__promo-next-tag--product-discount">' + propertyPercent + '% OFF</span>';
        }

        if (compareAtUnit > finalUnitPrice && finalUnitPrice > 0) {
          var pct = Math.round(((compareAtUnit - finalUnitPrice) / compareAtUnit) * 100);
          if (pct > 0) {
            return '<span class="pcz-cart__promo-next-tag pcz-cart__promo-next-tag--product-discount">' + pct + '% OFF</span>';
          }
        }

        if (compareLineFromProperty > finalLinePrice && finalLinePrice > 0) {
          var pctProp = Math.round(((compareLineFromProperty - finalLinePrice) / compareLineFromProperty) * 100);
          if (pctProp > 0) {
            return '<span class="pcz-cart__promo-next-tag pcz-cart__promo-next-tag--product-discount">' + pctProp + '% OFF</span>';
          }
        }

        var info = CartRenderer._getItemDiscountInfo(item, cart);
        if (!info.show || !info.percent || info.percent <= 0) return '';
        return '<span class="pcz-cart__promo-next-tag pcz-cart__promo-next-tag--product-discount">' + info.percent + '% OFF</span>';
      })();

      /* Kit 3 com quantidade > 1: a linha mostra "N×" e o preço de 1 kit (o total do carrinho soma tudo) */
      var priceDivisor = (qty > 1 && !isLocked && KitMap.isKit3Item(item)) ? qty : 1;
      var shownFinalPrice = Math.round(finalLinePrice / priceDivisor);
      var shownOldPrice = Math.round(oldPriceToShow / priceDivisor);

      var priceHtml = '';
      if (shownOldPrice > shownFinalPrice) {
        priceHtml =
          '<span class="pcz-cart__item-price-old">' + moneyBRL(shownOldPrice) + '</span>' +
          '<span class="pcz-cart__item-price-final pcz-cart__item-price-final--discount">' + moneyBRL(shownFinalPrice) + '</span>';
      } else {
        priceHtml = '<span class="pcz-cart__item-price-final">' + moneyBRL(shownFinalPrice) + '</span>';
      }

      var minusIcon = item.quantity <= 1
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M6 6l1 14h10l1-14"/><path d="M10 10v6"/><path d="M14 10v6"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg>';

      var minusLabel = item.quantity <= 1 ? 'Remover item' : 'Diminuir';

      /* Linha com valor final R$ 0 (100% de desconto): não oferece "Adicionar + 1 Pote" */
      var isFreeLine = qty > 0 && finalLinePrice <= 0;

      var qtyHtml = isLocked
        ?'<div class="pcz-cart__qty-locked"><span class="pcz-cart__qty-locked-label">Qtd</span><strong>' + item.quantity + '</strong></div>'
        : '<div class="pcz-cart__qty pcz-cart__qty--add" data-item-key="' + itemKey + '" data-line="' + line + '">' +
            (item.quantity > 1 ? '<span class="pcz-cart__qty-count">' + item.quantity + '×</span>' : '') +
            '<input class="pcz-cart__qty-input" type="hidden" value="' + item.quantity + '" data-item-key="' + itemKey + '" data-line="' + line + '">' +
            (KitMap.isKit3Item(item) || isFreeLine ? '' :
              '<button class="pcz-cart__qty-btn pcz-cart__add-one" type="button" data-action="plus" aria-label="Adicionar mais 1 pote">' +
                'Adicionar + 1 Pote' +
              '</button>') +
          '</div>';

      var removeHtml = isGift
        ? ''
        : '<button class="pcz-cart__item-remove" data-item-key="' + itemKey + '" data-line="' + line + '" aria-label="Remover item">' +
            '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>';

      var imgSrc = item.image
        ? item.image.replace('_grande', '_medium').replace('_large', '_medium')
        : '';
      var imgHtml = imgSrc
        ? '<img class="pcz-cart__item-img" src="' + imgSrc + '" alt="' + (item.product_title || '') + '" loading="lazy">'
        : '';

      var promoNextTag = CartRenderer._getNextStepTag(item, cart);

      /*
        ── Nome do produto: com ou sem link ──
        Se o product_id estiver na lista de bloqueados, renderiza
        como <span> sem cursor de pointer. Caso contrário, mantém
        o <a href> original.
      */
      var productNameHtml = isLinkBlocked
        ? '<span class="pcz-cart__item-name pcz-cart__item-name--no-link">' + item.product_title + '</span>'
        : '<a href="' + item.url + '" class="pcz-cart__item-name">' + item.product_title + '</a>';

      var hasAddButton = !isLocked && !KitMap.isKit3Item(item) && !isFreeLine;

      return '<div class="pcz-cart__item' + (hasAddButton ? '' : ' pcz-cart__item--no-add') + '" data-item-key="' + itemKey + '" data-line="' + line + '" data-variant-id="' + item.variant_id + '">' +
        '<div class="pcz-cart__item-img-wrap">' + imgHtml + '</div>' +
        '<div class="pcz-cart__item-details">' +
          '<div class="pcz-cart__item-name-row">' +
            productNameHtml +
            productDiscountTag +
            promoNextTag +
          '</div>' +
          variantInfo +
          discountBadge +
          (isGift ? '<div class="pcz-cart__item-gift-badge">Brinde</div>' : '') +
          '<div class="pcz-cart__item-bottom">' +
            qtyHtml +
            '<div class="pcz-cart__item-price">' + priceHtml + '</div>' +
          '</div>' +
        '</div>' +
        removeHtml +
      '</div>';
    }).join('');

    this.bindItemEvents(container);
  },

  bindItemEvents: function (container) {
    $$('.pcz-cart__qty-btn', container).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.pcz-cart__qty');
        var itemKey = wrap.dataset.itemKey;
        var input = wrap.querySelector('.pcz-cart__qty-input');
        var qty = parseInt(input.value, 10);

        if (isNaN(qty) || qty < 1) qty = 1;

        var next;

        if (btn.dataset.action === 'plus') {
          next = qty + 1;
        } else {
          next = qty <= 1 ? 0 : qty - 1;
        }

        input.value = next > 0 ? next : 1;
        CartActions.updateLine(itemKey || parseInt(wrap.dataset.line, 10), next, btn.dataset.action);
      });
    });

    $$('.pcz-cart__qty-input', container).forEach(function (input) {
      input.addEventListener('change', debounce(function () {
        var itemKey = input.dataset.itemKey;
        var qty = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = qty;
        CartActions.updateLine(itemKey || parseInt(input.dataset.line, 10), qty);
      }, 400));
    });

    $$('.pcz-cart__item-remove', container).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var itemKey = btn.dataset.itemKey;
        CartActions.updateLine(itemKey || parseInt(btn.dataset.line, 10), 0);
      });
    });
  },

  renderTotal: function (cart) {
    var el = $('#PcozCartTotal');
    if (!el) return;

    var originalTotal = 0;
    var finalTotal = Number(cart.total_price || 0);

    (cart.items || []).forEach(function (item) {
      originalTotal += Number(
        item.original_line_price != null ? item.original_line_price : item.final_line_price
      ) || 0;
    });

    var hasDiscount = originalTotal > finalTotal;

    if (hasDiscount) {
      el.innerHTML =
        '<span class="pcz-cart__total-compare">' + moneyBRL(originalTotal) + '</span>' +
        '<span class="pcz-cart__total-final">' + moneyBRL(finalTotal) + '</span>';
    } else {
      el.innerHTML =
        '<span class="pcz-cart__total-final">' + moneyBRL(finalTotal) + '</span>';
    }
  },

  updateShippingProgress: function (cart) {
    var box = $('#PcozShippingProgress');
    if (!box) return;

    var threshold = Number(box.dataset.threshold || 0);
    var items = (cart && cart.items) || [];
    if (threshold <= 0 || !items.length) {
      box.hidden = true;
      return;
    }

    var total = Number(cart.total_price || 0);
    var missing = Math.max(0, threshold - total);
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var text = box.querySelector('[data-shipping-text]');
    var fill = box.querySelector('[data-shipping-fill]');
    var track = box.querySelector('.pcz-shipping-progress__track');

    if (text) {
      if (missing > 0) {
        var msg = box.dataset.message || 'Faltam [valor] para você ganhar frete grátis';
        text.innerHTML = msg.replace('[valor]', '<strong>' + moneyBRL(missing) + '</strong>');
      } else {
        text.textContent = box.dataset.messageDone || 'Você ganhou frete grátis 🎉';
      }
    }
    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', String(pct));
    box.hidden = false;
  },

  updateFreeShippingBanner: function (cart) {
    var banner = $('#PcozFreeShippingBanner');
    if (!banner) return;

    var threshold = Number(banner.dataset.threshold || 0);
    var total = Number(cart.total_price || 0);

    if (threshold > 0 && total >= threshold) {
      banner.style.display = 'block';
    } else {
      banner.style.display = 'none';
    }
  },

  _getPromoBar: function () {
    var drawer = $('#PcozCartDrawer');
    return drawer ? $('#PcozCartPromoBar', drawer) : $('#PcozCartPromoBar');
  },

  _getPromoDisplayMode: function () {
    var drawer = $('#PcozCartDrawer');
    return drawer ? String(drawer.dataset.promoDisplayMode || 'progress_bar') : 'progress_bar';
  },

  _getPercentDiscountMarkers: function () {
    var bar = this._getPromoBar();
    if (!bar) return [];

    return $$('[data-pcz-marker]', bar)
      .filter(function (marker) {
        return marker.dataset.promoType === 'percent_discount' &&
          marker.dataset.triggerType === 'same_product_qty';
      })
      .sort(function (a, b) {
        return Number(a.dataset.threshold || 0) - Number(b.dataset.threshold || 0);
      });
  },

  _getNextStepTag: function (item, cart) {
    if (this._getPromoDisplayMode() !== 'product_tag') return '';

    var isGift = item.properties && item.properties['_promo_gift'] === 'true';
    var isUpsell = item.properties && item.properties['_upsell'] === 'true';
    if (isGift || isUpsell) return '';

    var markers = this._getPercentDiscountMarkers();
    if (!markers.length) return '';

    var qty = Number(item.quantity || 0);
    if (qty <= 0) return '';

    var productMarkers = markers
      .filter(function (marker) {
        return isItemIncludedInPromo(item, marker);
      })
      .sort(function (a, b) {
        return Number(a.dataset.threshold || 0) - Number(b.dataset.threshold || 0);
      });

    if (!productMarkers.length) return '';

    var nextMarker = null;

    for (var i = 0; i < productMarkers.length; i++) {
      var threshold = Number(productMarkers[i].dataset.threshold || 0);
      if (threshold > qty) {
        nextMarker = productMarkers[i];
        break;
      }
    }

    if (!nextMarker) return '';

    var nextThreshold = Number(nextMarker.dataset.threshold || 0);

    var benefitLabel = nextMarker.dataset.title || '';
    if (!benefitLabel) {
      var labelEl = nextMarker.querySelector('.pcz-cart__promo-label');
      benefitLabel = labelEl ? labelEl.textContent.trim() : '';
    }

    if (!benefitLabel) return '';

    var percentMatch = benefitLabel.match(/(\d+)\s*%/);
    if (!percentMatch) return '';

    var percentValue = percentMatch[1];

    var thresholdText = nextThreshold >= 3
      ? nextThreshold + ' ou mais'
      : String(nextThreshold);

    return '<span class="pcz-cart__promo-next-tag">Leve ' + thresholdText + ' com ' + percentValue + '% de desconto</span>';
  },

  _getProductDiscountTag: function (item, cart) {
    var isGift = item.properties && item.properties['_promo_gift'] === 'true';
    var isUpsell = item.properties && item.properties['_upsell'] === 'true';
    if (isGift || isUpsell) return '';

    var propertyPercent = 0;
    if (item.properties && item.properties._product_compare_discount != null) {
      propertyPercent = parseInt(item.properties._product_compare_discount, 10) || 0;
    }

    if (propertyPercent > 0) {
      return '<span class="pcz-cart__promo-next-tag pcz-cart__promo-next-tag--product-discount">' + propertyPercent + '% OFF</span>';
    }

    var info = this._getItemDiscountInfo(item, cart);
    if (!info.show || !info.percent || info.percent <= 0) return '';

    return '<span class="pcz-cart__promo-next-tag pcz-cart__promo-next-tag--product-discount">' + info.percent + '% OFF</span>';
  },

  _getGiftMarkers: function () {
    var bar = this._getPromoBar();
    if (!bar) return [];
    return $$('[data-pcz-marker]', bar).filter(function (marker) {
      return marker.dataset.promoType === 'gift';
    });
  },

  _isItemExcludedFromAnyGiftPromo: function (item) {
    var markers = this._getGiftMarkers();
    return isItemExcludedFromMarkers(item, markers);
  },

  _getLineDiscountPercent: function (item) {
    var original = Number(item.original_line_price || 0);
    var finalPrice = Number(item.final_line_price || 0);
    if (!original || original <= 0 || finalPrice >= original) return 0;
    return Math.round(((original - finalPrice) / original) * 100);
  },

  _hasRealDiscountAppliedToItem: function (item, cart) {
    var original = Number(item.original_line_price || 0);
    var finalPrice = Number(item.final_line_price || 0);
    if (original > 0 && finalPrice < original) return true;
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) return true;
    if (item.discount_allocations && item.discount_allocations.length) return true;
    return false;
  },

  _getItemDiscountInfo: function (item, cart) {
    var isGift = item.properties && item.properties['_promo_gift'] === 'true';
    var isUpsell = item.properties && item.properties['_upsell'] === 'true';
    if (isGift || isUpsell) {
      return { show: false, percent: 0, type: '' };
    }

    var lineDiscountPercent = this._getLineDiscountPercent(item);
    var hasRealDiscount = this._hasRealDiscountAppliedToItem(item, cart);

    if (!hasRealDiscount || lineDiscountPercent <= 0) {
      return { show: false, percent: 0, type: '' };
    }

    return { show: true, percent: lineDiscountPercent, type: 'applied_discount' };
  },

  _getActiveDiscount: function (cart) {
    var bar = this._getPromoBar();
    if (!bar) return 0;

    var markers = $$('[data-pcz-marker]', bar);
    if (!markers.length) return 0;

    var bestDiscount = 0;

    markers.forEach(function (marker) {
      if (marker.dataset.promoType !== 'percent_discount') return;

      var tt = marker.dataset.triggerType;
      var metrics = getDiscountEligibleMetricsForMarker(cart, marker);
      var thr = Number(marker.dataset.threshold);
      var cur = 0;

      if (tt === 'subtotal') cur = metrics.subtotal;
      else if (tt === 'item_count') cur = metrics.itemCount;
      else if (tt === 'same_product_qty') cur = metrics.maxQty;

      if (thr > 0 && cur >= thr) {
        var label = (marker.querySelector('.pcz-cart__promo-label') || {}).textContent || '';
        var match = label.match(/(\d+)\s*%/);
        if (match) {
          var pct = parseInt(match[1], 10);
          if (pct > bestDiscount) bestDiscount = pct;
        }
      }
    });

    return bestDiscount;
  },

  updateEmpty: function (cart) {
    var empty = $('#PcozCartEmpty');
    var content = $('#PcozCartContent');
    var footer = $('#PcozCartFooter');
    var isEmpty = !cart.items || cart.items.length === 0;

    if (empty) empty.classList.toggle('is-visible', isEmpty);
    if (content) content.style.display = isEmpty ? 'none' : '';
    if (footer) footer.style.display = isEmpty ? 'none' : '';
  },

  updateBadge: function (count) {
    $$('[data-cart-count], .cart-count-bubble, .pcz-cart-count').forEach(function (el) {
      el.textContent = count || '';
      el.style.display = count > 0 ? '' : 'none';
    });
  }
};

/* ─────────────────────────────────────────────────────────────
CART ACTIONS
───────────────────────────────────────────────────────────── */

/* Mapa produto -> kits (custom.kit_2_product / kit_3_product), lido do feed procapz-kits */
var KitMap = {
  _promise: null,
  index: null,

  isKit3Item: function (item) {
    if (this.index) {
      var info = this.index.byVariant[item.variant_id];
      if (info) return info.size === 3;
    }
    return /^s*kits*3/i.test(String(item.product_title || ''));
  },

  load: function () {
    if (this._promise) return this._promise;

    var cacheKey = 'pcz_kit_map_v1';
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && cached.t && Date.now() - cached.t < 3600000 && cached.items) {
        this.index = this._index(cached.items);
        this._promise = Promise.resolve(this.index);
        return this._promise;
      }
    } catch (e) {}

    var self = this;
    var base = '/collections/all?view=procapz-kits';
    var themeId = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main') ? window.Shopify.theme.id : '';
    if (themeId) base += '&preview_theme_id=' + themeId;

    function page(n) {
      return fetch(base + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    }

    this._promise = page(1).then(function (first) {
      var pages = first.pages || 1;
      var rest = [];
      for (var p = 2; p <= pages; p++) rest.push(page(p));
      return Promise.all(rest).then(function (others) {
        var items = first.items || [];
        others.forEach(function (o) { items = items.concat(o.items || []); });
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        self.index = self._index(items);
        return self.index;
      });
    }).catch(function () {
      self._promise = null;
      return null;
    });

    return this._promise;
  },

  _index: function (items) {
    var byVariant = {};
    items.forEach(function (entry) {
      byVariant[entry.v] = { size: 1, entry: entry, base: true };
      if (entry.k2) byVariant[entry.k2] = { size: 2, entry: entry };
      if (entry.k3) byVariant[entry.k3] = { size: 3, entry: entry };
    });
    var byProduct = {};
    items.forEach(function (entry) { byProduct[entry.p] = entry; });
    return { byVariant: byVariant, byProduct: byProduct };
  }
};

KitMap.load();

function findCartItem(cart, lineOrKey) {
  var items = (cart && cart.items) || [];
  if (typeof lineOrKey === 'string' && lineOrKey.indexOf(':') >= 0) {
    return items.filter(function (i) { return i.key === lineOrKey; })[0] || null;
  }
  return items[Number(lineOrKey) - 1] || null;
}

/* Reagrupa as unidades do mesmo produto (avulsas + Kit 2 + Kit 3) em Kit 3 (xN) + Kit 2 / unidade avulsa */
function planKitRegroup(item, qty, map, action, cart) {
  if (!item || !map) return null;
  if (item.properties && item.properties._promo_gift === 'true') return null;

  var info = map.byVariant[item.variant_id];
  if (!info) {
    var byProduct = map.byProduct[item.product_id];
    if (!byProduct) return null;
    info = { size: 1, entry: byProduct, base: true };
  }

  var entry = info.entry;
  if (!entry.k3 && !entry.k2) return null;

  var cartItems = (cart && cart.items) || [];
  var isPlain = function (i) { return !(i.properties && (i.properties._promo_gift === 'true' || i.properties._upsell === 'true')); };

  /* variante da unidade avulsa: a da linha clicada, ou a que já está no carrinho, ou a padrão */
  var unitVariant = info.size === 1 ? item.variant_id : 0;
  if (!unitVariant) {
    var existingUnit = cartItems.filter(function (i) {
      return isPlain(i) && i.product_id === entry.p && Number(i.variant_id) !== Number(entry.k2) && Number(i.variant_id) !== Number(entry.k3);
    })[0];
    unitVariant = existingUnit ? existingUnit.variant_id : entry.v;
  }

  var sizeOf = function (variantId) {
    if (Number(variantId) === Number(entry.k3)) return 3;
    if (Number(variantId) === Number(entry.k2)) return 2;
    if (Number(variantId) === Number(unitVariant)) return 1;
    return 0;
  };

  var lines = cartItems.filter(function (i) { return isPlain(i) && sizeOf(i.variant_id) > 0; });
  if (lines.indexOf(item) === -1 && lines.filter(function (i) { return i.key === item.key; }).length === 0) return null;

  var totalUnits = 0;
  lines.forEach(function (i) { totalUnits += i.quantity * sizeOf(i.variant_id); });

  var clickedUnits = item.quantity * sizeOf(item.variant_id);
  var newUnits;
  if (action === 'plus') newUnits = totalUnits + 1;
  else if (action === 'minus') newUnits = totalUnits - 1;
  else if (qty >= 1) newUnits = totalUnits - clickedUnits + qty * sizeOf(item.variant_id);
  else return null;

  if (newUnits < 1 || newUnits === totalUnits) return null;

  var desired = [];
  var kit3 = entry.k3 ? Math.floor(newUnits / 3) : 0;
  var rest = newUnits - kit3 * 3;

  if (kit3 > 0) desired.push({ id: entry.k3, quantity: kit3 });

  if (rest === 2 && entry.k2) {
    desired.push({ id: entry.k2, quantity: 1 });
  } else if (rest > 0) {
    desired.push({ id: unitVariant, quantity: rest });
  }

  return { desired: desired, lines: lines };
}

var CartActions = {
  updateLine: function (line, qty, action) {
    CartRenderer.setLoading(true);

    var item = findCartItem(CartState.cart, line);

    var normal = function () {
      return cartChange(line, qty);
    };

    var regroup = item ? KitMap.load().then(function (map) {
      var result = planKitRegroup(item, qty, map, action, CartState.cart);
      if (!result || !result.desired.length) return normal();

      var desired = result.desired;
      var lines = result.lines;

      var props = {};
      Object.keys(item.properties || {}).forEach(function (k) {
        if (k.indexOf('_product_compare') === 0) return;
        props[k] = item.properties[k];
      });

      var inCart = {};
      lines.forEach(function (l) { inCart[l.variant_id] = true; });
      var toAdd = desired.filter(function (d) { return !inCart[d.id]; });

      var withProps = function (list) {
        return Promise.all(list.map(function (p) {
          return fetchVariantCompareData(p.id).then(function (v) {
            var properties = Object.assign({}, props);
            if (v && v.compareAt > v.price && v.discountPercent > 0) {
              properties._product_compare_price = String(Math.round(v.compareAt));
              properties._product_compare_discount = String(v.discountPercent);
            }
            return { id: p.id, quantity: p.quantity, properties: properties };
          });
        }));
      };

      /* Adiciona primeiro as linhas novas: se falhar (ex.: estoque), nada é perdido */
      return (toAdd.length ? withProps(toAdd).then(cartAdd) : Promise.resolve()).then(function () {
        var chain = Promise.resolve();
        lines.forEach(function (l) {
          var target = desired.filter(function (d) { return Number(d.id) === Number(l.variant_id); })[0];
          var newQty = target ? target.quantity : 0;
          if (newQty === l.quantity) return;
          chain = chain.then(function () { return cartChange(l.key, newQty); });
        });
        return chain;
      }).then(function () {
        return CartState.load();
      });
    }) : normal();

    regroup.then(function (cart) {
      CartState.cart = cart;
      CartRenderer.render(cart);
      CartRenderer.setLoading(false);
    }).catch(function (err) {
      console.error('[PcozCart] Falha ao atualizar item:', err);
      /* Re-sincroniza a tela com o carrinho real */
      CartState.load().then(function (cart) {
        CartRenderer.render(cart);
      }).catch(function () {}).then(function () {
        CartRenderer.setLoading(false);
      });
    });
  },

  addItem: function (variantId, quantity, properties) {
    return cartAdd([{
      id: variantId,
      quantity: quantity || 1,
      properties: properties || {}
    }]).then(function () {
      return CartState.load();
    }).then(function (cart) {
      CartRenderer.render(cart);
      return cart;
    });
  },

  clearCart: function () {
    if (!confirm('Deseja remover todos os itens do carrinho?')) return;

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(parseJsonResponse)
      .then(function (cart) {
        CartState.cart = cart;
        CartRenderer.render(cart);
      })
      .catch(function (err) {
        console.error('[PcozCart] Falha ao limpar carrinho:', err);
      });
  }
};

/* ─────────────────────────────────────────────────────────────
PROMO BAR
───────────────────────────────────────────────────────────── */

var PromoBar = {
  _busyGiftAdd: false,
  _busyGiftRemove: new Set(),
  _lastAppliedDiscount: '',
  _queuedDiscountCode: '',
  _discountRequestInFlight: false,
  _discountRemovalInFlight: false,

  syncCartUI: function (cart) {
    CartState.cart = cart;
    CartRenderer.render(cart);
    return cart;
  },

  getSavingsSummary: function (cart) {
    cart = cart || CartState.cart || {};

    var items = cart.items || [];
    var originalTotal = 0;
    var finalItemsTotal = 0;
    var discountApplicationCount = 0;
    var hasGift = false;

    items.forEach(function (item) {
      var originalLine = Number(item.original_line_price != null ? item.original_line_price : 0);
      var finalLine = Number(item.final_line_price != null ? item.final_line_price : 0);

      originalTotal += originalLine;
      finalItemsTotal += finalLine;

      if (originalLine > finalLine) {
        discountApplicationCount += 1;
      }

      if (item.properties && item.properties['_promo_gift'] === 'true') {
        hasGift = true;
      }
    });

    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      discountApplicationCount += cart.cart_level_discount_applications.length;
    }

    var finalCartTotal = Number(cart.total_price || 0);
    var savingsValue = Math.max(0, originalTotal - finalCartTotal);

    return {
      originalTotal: originalTotal,
      finalItemsTotal: finalItemsTotal,
      finalCartTotal: finalCartTotal,
      savingsValue: savingsValue,
      hasSavings: savingsValue > 0,
      hasGift: hasGift,
      discountApplicationCount: discountApplicationCount
    };
  },

  updateDiscountBadgeSummary: function (cart) {
    var badge = $('#PcozDiscountBadge');
    var label = $('#PcozDiscountLabel');
    if (!badge || !label) return;

    var summary = PromoBar.getSavingsSummary(cart);

    if (!summary.hasSavings) {
      badge.classList.remove('is-visible');
      label.textContent = 'Desconto aplicado';
      return;
    }

    badge.classList.add('is-visible');

    if (summary.hasGift) {
      label.textContent = 'Você economizou ' + moneyBRL(summary.savingsValue) + ' em descontos e brindes neste pedido!';
    } else {
      label.textContent = 'Você economizou ' + moneyBRL(summary.savingsValue) + ' em descontos neste pedido!';
    }
  },

  clearDiscountBadge: function () {
    var badge = $('#PcozDiscountBadge');
    var label = $('#PcozDiscountLabel');
    if (badge) badge.classList.remove('is-visible');
    if (label) label.textContent = 'Desconto aplicado';
  },

  getAppliedDiscountCodes: function (cart) {
    cart = cart || CartState.cart || {};

    var codes = [];
    var applications = cart.cart_level_discount_applications || [];

    applications.forEach(function (app) {
      var title = app && (app.title || app.code || app.discount_code);
      if (title && codes.indexOf(String(title).trim()) === -1) {
        codes.push(String(title).trim());
      }
    });

    return codes;
  },

  _flushQueuedDiscount: function () {
    var queued = (PromoBar._queuedDiscountCode || '').trim();
    PromoBar._queuedDiscountCode = '';

    if (!queued) return;
    if (queued === PromoBar._lastAppliedDiscount) return;

    setTimeout(function () {
      PromoBar.applyDiscount(queued, true, '');
    }, 80);
  },

  hasAppliedDiscount: function (cart) {
    cart = cart || CartState.cart || {};
    if (PromoBar._lastAppliedDiscount) return true;
    return PromoBar.getAppliedDiscountCodes(cart).length > 0;
  },

  applyDiscount: function (code, force, messageOverride) {
    code = (code || '').trim();
    if (!code) return Promise.resolve(null);

    if ((PromoBar._discountRemovalInFlight || PromoBar._discountRequestInFlight) && !force) {
      PromoBar._queuedDiscountCode = code;
      return Promise.resolve(CartState.cart);
    }

    var currentCodes = PromoBar.getAppliedDiscountCodes(CartState.cart);
    var alreadyAppliedInCart = currentCodes.indexOf(code) !== -1;
    var hasDifferentDiscount = currentCodes.length > 0 && !alreadyAppliedInCart;

    if (!force && (PromoBar._lastAppliedDiscount === code || alreadyAppliedInCart) && !hasDifferentDiscount) {
      PromoBar._lastAppliedDiscount = code;
      return CartState.load().then(function (cart) {
        CartState.cart = cart;
        CartRenderer.renderSilent(cart);
        PromoBar.updateDiscountBadgeSummary(cart);
        return cart;
      });
    }

    PromoBar._discountRequestInFlight = true;

    var mustClearFirst = hasDifferentDiscount || (PromoBar._lastAppliedDiscount && PromoBar._lastAppliedDiscount !== code);
    var sequence = Promise.resolve(CartState.cart);

    if (mustClearFirst) {
      sequence = cartUpdateDiscount('')
        .then(function (cart) {
          PromoBar._lastAppliedDiscount = '';
          CartState.cart = cart;
          return wait(150);
        });
    }

    return sequence
      .then(function () {
        return cartUpdateDiscount(code);
      })
      .then(function (cart) {
        PromoBar._lastAppliedDiscount = code;
        CartState.cart = cart;
        CartRenderer.renderSilent(cart);
        PromoBar.updateDiscountBadgeSummary(cart);
        return cart;
      })
      .catch(function (err) {
        console.error('[PcozCart] Falha ao aplicar desconto:', err);
        throw err;
      })
      .finally(function () {
        PromoBar._discountRequestInFlight = false;
        PromoBar._flushQueuedDiscount();
      });
  },

  removeDiscount: function (force) {
    if (PromoBar._queuedDiscountCode && !force) return Promise.resolve(CartState.cart);
    if (PromoBar._discountRequestInFlight && !force) return Promise.resolve(CartState.cart);
    if (PromoBar._discountRemovalInFlight && !force) return Promise.resolve(CartState.cart);

    if (!force && !PromoBar.hasAppliedDiscount(CartState.cart)) {
      PromoBar.updateDiscountBadgeSummary(CartState.cart);
      return Promise.resolve(CartState.cart);
    }

    PromoBar._discountRemovalInFlight = true;

    return cartUpdateDiscount('')
      .then(function (cart) {
        PromoBar._lastAppliedDiscount = '';
        CartState.cart = cart;
        CartRenderer.renderSilent(cart);
        PromoBar.updateDiscountBadgeSummary(cart);
        return cart;
      })
      .catch(function (err) {
        console.error('[PcozCart] Falha ao remover desconto:', err);
        throw err;
      })
      .finally(function () {
        PromoBar._discountRemovalInFlight = false;
        PromoBar._flushQueuedDiscount();
      });
  },

  evaluate: function (cart) {
    var drawer = $('#PcozCartDrawer');
    var bar = drawer ? $('#PcozCartPromoBar', drawer) : $('#PcozCartPromoBar');
    if (!bar) return;

    var markers = $$('[data-pcz-marker]', bar);
    if (!markers.length) {
      PromoBar.updateDiscountBadgeSummary(cart);
      return;
    }

    markers.sort(function (a, b) {
      return Number(a.dataset.visualPos) - Number(b.dataset.visualPos);
    });

    var allRealItems = getNonGiftItems(cart);
    var allRealMetrics = buildMetricsFromItems(allRealItems);

    function curVal(marker) {
      var tt = marker.dataset.triggerType;

      if (marker.dataset.promoType === 'gift') {
        var giftMetrics = getGiftEligibleMetrics(cart, marker);
        if (tt === 'subtotal') return giftMetrics.subtotal;
        if (tt === 'item_count') return giftMetrics.itemCount;
        if (tt === 'same_product_qty') return giftMetrics.maxQty;
        return 0;
      }

      if (marker.dataset.promoType === 'percent_discount') {
        var discountMetrics = getDiscountEligibleMetricsForMarker(cart, marker);
        if (tt === 'subtotal') return discountMetrics.subtotal;
        if (tt === 'item_count') return discountMetrics.itemCount;
        if (tt === 'same_product_qty') return discountMetrics.maxQty;
        return 0;
      }

      if (tt === 'subtotal') return allRealMetrics.subtotal;
      if (tt === 'item_count') return allRealMetrics.itemCount;
      if (tt === 'same_product_qty') return allRealMetrics.maxQty;
      return 0;
    }

    function cartHasGiftVariant(giftVariantId) {
      return (cart.items || []).some(function (item) {
        return String(item.variant_id) === String(giftVariantId) &&
          item.properties &&
          item.properties['_promo_gift'] === 'true';
      });
    }

    function getMarkerCenterPct(marker) {
      var value = Number(marker && marker.dataset ? marker.dataset.visualPos : 0);
      if (!isFinite(value)) value = 0;
      var edgeGap = 18;
      var usableWidth = 64;
      var normalized = (value - edgeGap) / usableWidth * 100;
      return Math.max(0, Math.min(100, normalized));
    }

    function clampPct(value) {
      value = Number(value);
      if (!isFinite(value)) value = 0;
      return Math.max(0, Math.min(100, value));
    }

    var messageEl = $('#PcozPromoMessage', bar);
    var fill = $('.pcz-cart__promo-fill', bar);

    var lastDone = null;
    var nextLocked = null;
    var ineligibleGiftMarker = null;

    markers.forEach(function (marker) {
      var threshold = Number(marker.dataset.threshold || 0);
      var current = curVal(marker);
      var done = threshold > 0 && current >= threshold;

      var isIneligibleGift = done &&
        marker.dataset.promoType === 'gift' &&
        !cartQualifiesForGift(cart, marker);

      if (isIneligibleGift) {
        done = false;
        ineligibleGiftMarker = marker;
      }

      marker.classList.toggle('is-done', done);
      marker.classList.remove('just-hit');

      if (done) {
        lastDone = marker;
      } else if (!nextLocked) {
        nextLocked = marker;
      }
    });

    function getNextMarker(marker) {
      var idx = markers.indexOf(marker);
      if (idx === -1) return null;
      return markers[idx + 1] || null;
    }

    function getMidpointToNext(marker) {
      var currentCenter = getMarkerCenterPct(marker);
      var nextMarker = getNextMarker(marker);
      if (!nextMarker) return 100;
      var nextCenter = getMarkerCenterPct(nextMarker);
      return currentCenter + ((nextCenter - currentCenter) / 2);
    }

    var fillPct = 0;

    if (!allRealMetrics.hasEligibleItems) {
      fillPct = 0;
    } else if (lastDone) {
      fillPct = getMidpointToNext(lastDone);
    } else {
      var firstMarker = markers[0];
      var firstThreshold = Number(firstMarker.dataset.threshold || 0);
      var firstTarget = getMidpointToNext(firstMarker);

      if (firstThreshold > 0) {
        fillPct = clampPct((curVal(firstMarker) / firstThreshold) * firstTarget);
      } else {
        fillPct = 0;
      }
    }

    if (fill) {
      fill.style.width = fillPct + '%';

      if (lastDone && lastDone.dataset.color) {
        fill.style.background = lastDone.dataset.color;
      } else if (markers[0] && markers[0].dataset.color) {
        fill.style.background = markers[0].dataset.color;
      }
    }

    if (messageEl) {
      if (!allRealMetrics.hasEligibleItems) {
        messageEl.innerHTML = 'Adicione produtos para desbloquear as promoções.';
        messageEl.className = 'pcz-cart__promo-message';
      } else if (ineligibleGiftMarker && !nextLocked) {
        var giftThreshold = Number(ineligibleGiftMarker.dataset.threshold || 0);
        var giftCurrent = curVal(ineligibleGiftMarker);
        var giftMissing = Math.max(0, giftThreshold - giftCurrent);
        var giftTitleEl = $('.pcz-cart__promo-label', ineligibleGiftMarker);
        var giftTitle = giftTitleEl ? giftTitleEl.textContent.trim() : 'o brinde';

        if (giftMissing > 0) {
          if (ineligibleGiftMarker.dataset.triggerType === 'subtotal') {
            messageEl.innerHTML = 'Faltam <strong>' + moneyBRL(giftMissing) + '</strong> para desbloquear <strong>' + giftTitle + '</strong>';
          } else {
            messageEl.innerHTML = 'Faltam <strong>' + giftMissing + '</strong> para desbloquear <strong>' + giftTitle + '</strong>';
          }
          messageEl.className = 'pcz-cart__promo-message';
        } else {
          var ineligibleMsg = ineligibleGiftMarker.dataset.ineligibleMessage ||
            '⚠️ O produto no seu carrinho não é elegível para o brinde desta promoção.';
          messageEl.innerHTML = '<span class="pcz-cart__promo-ineligible">' + ineligibleMsg + '</span>';
          messageEl.className = 'pcz-cart__promo-message pcz-cart__promo-message--ineligible';
        }
      } else if (nextLocked) {
        var currentValue = curVal(nextLocked);
        var thresholdValue = Number(nextLocked.dataset.threshold || 0);
        var missing = Math.max(0, thresholdValue - currentValue);
        var titleEl = $('.pcz-cart__promo-label', nextLocked);
        var title = titleEl ? titleEl.textContent.trim() : 'a próxima promoção';

        if (nextLocked.dataset.triggerType === 'subtotal') {
          messageEl.innerHTML = 'Faltam <strong>' + moneyBRL(missing) + '</strong> para desbloquear <strong>' + title + '</strong>';
        } else {
          messageEl.innerHTML = 'Faltam <strong>' + missing + '</strong> para desbloquear <strong>' + title + '</strong>';
        }
        messageEl.className = 'pcz-cart__promo-message';
      } else if (lastDone) {
        var doneTitleEl = $('.pcz-cart__promo-label', lastDone);
        var doneTitle = doneTitleEl ? doneTitleEl.textContent.trim() : 'promoção';
        messageEl.innerHTML = 'Você desbloqueou: <strong>' + doneTitle + '</strong> 🎉';
        messageEl.className = 'pcz-cart__promo-message';
      }
    }

    markers.forEach(function (marker) {
      var isGiftPromo = marker.dataset.promoType === 'gift';
      var giftVariantId = marker.dataset.giftVariant;
      var giftDiscountMode = normalizeDiscountMode(marker.dataset.giftDiscountMode);
      var giftDiscountValue = parseDiscountValue(marker.dataset.giftDiscountValue);
      var isDone = marker.classList.contains('is-done');

      if (!isGiftPromo || !giftVariantId) return;

      var alreadyInCart = cartHasGiftVariant(giftVariantId);
      var qualifies = cartQualifiesForGift(cart, marker);
      var giftTargetQty = getGiftTargetQty(cart, marker);

      var giftInCart = (cart.items || []).find(function (item) {
        return String(item.variant_id) === String(giftVariantId) &&
          item.properties &&
          item.properties['_promo_gift'] === 'true';
      });

      if (isDone && qualifies && giftInCart && giftInCart.quantity !== giftTargetQty &&
          !PromoBar._busyGiftAdd && !PromoBar._busyGiftRemove.has(String(giftVariantId))) {
        /* Ajusta a quantidade do brinde ao número de kits/unidades participantes */
        PromoBar._busyGiftRemove.add(String(giftVariantId));
        cartChange(giftInCart.key || giftInCart.id, giftTargetQty)
          .then(function (newCart) {
            PromoBar._busyGiftRemove.delete(String(giftVariantId));
            CartState.cart = newCart;
            CartRenderer.render(newCart);
            PromoBar.evaluate(newCart);
          })
          .catch(function (err) {
            PromoBar._busyGiftRemove.delete(String(giftVariantId));
            console.error('[PcozCart] Falha ao ajustar quantidade do brinde:', err);
          });

      } else if (isDone && qualifies && !alreadyInCart && !PromoBar._busyGiftAdd) {
        PromoBar._busyGiftAdd = true;

        CartActions.addItem(
          parseInt(giftVariantId, 10),
          giftTargetQty,
          {
            _promo_gift: 'true',
            _promo_source: marker.dataset.threshold || '',
            _promo_discount_mode: giftDiscountMode || 'free',
            _promo_discount_value: String(giftDiscountValue || 100)
          }
        ).then(function (newCart) {
          PromoBar._busyGiftAdd = false;
          PromoBar.evaluate(newCart);
        }).catch(function (err) {
          PromoBar._busyGiftAdd = false;
          console.error('[PcozCart] Falha ao adicionar brinde:', err);
        });

      } else if (isDone && !qualifies && alreadyInCart && !PromoBar._busyGiftRemove.has(String(giftVariantId))) {
        var giftItemToRemove = (cart.items || []).find(function (item) {
          return String(item.variant_id) === String(giftVariantId) &&
            item.properties &&
            item.properties['_promo_gift'] === 'true';
        });

        if (giftItemToRemove) {
          PromoBar._busyGiftRemove.add(String(giftVariantId));
          cartChange(giftItemToRemove.key || giftItemToRemove.id, 0)
            .then(function (newCart) {
              PromoBar._busyGiftRemove.delete(String(giftVariantId));
              CartState.cart = newCart;
              CartRenderer.render(newCart);
              PromoBar.evaluate(newCart);
            })
            .catch(function (err) {
              PromoBar._busyGiftRemove.delete(String(giftVariantId));
              console.error('[PcozCart] Falha ao remover brinde (exclusão):', err);
            });
        }

      } else if (!isDone && alreadyInCart && !PromoBar._busyGiftRemove.has(String(giftVariantId))) {
        var giftItem = (cart.items || []).find(function (item) {
          return String(item.variant_id) === String(giftVariantId) &&
            item.properties &&
            item.properties['_promo_gift'] === 'true';
        });

        if (giftItem) {
          PromoBar._busyGiftRemove.add(String(giftVariantId));

          cartChange(giftItem.key || giftItem.id, 0)
            .then(function (newCart) {
              PromoBar._busyGiftRemove.delete(String(giftVariantId));
              CartState.cart = newCart;
              CartRenderer.render(newCart);
              PromoBar.evaluate(newCart);
            })
            .catch(function (err) {
              PromoBar._busyGiftRemove.delete(String(giftVariantId));
              console.error('[PcozCart] Falha ao remover brinde:', err);
            });
        }
      }
    });

    var bestDiscountMarker = null;

    markers.forEach(function (marker) {
      if (!marker.classList.contains('is-done')) return;
      if (marker.dataset.promoType !== 'percent_discount') return;

      if (!bestDiscountMarker) {
        bestDiscountMarker = marker;
        return;
      }

      var currentThreshold = Number(marker.dataset.threshold || 0);
      var bestThreshold = Number(bestDiscountMarker.dataset.threshold || 0);

      var currentLabel = (marker.querySelector('.pcz-cart__promo-label') || {}).textContent || marker.dataset.title || '';
      var bestLabel = (bestDiscountMarker.querySelector('.pcz-cart__promo-label') || {}).textContent || bestDiscountMarker.dataset.title || '';
      var currentPctMatch = String(currentLabel).match(/(\d+)\s*%/);
      var bestPctMatch = String(bestLabel).match(/(\d+)\s*%/);
      var currentPct = currentPctMatch ? parseInt(currentPctMatch[1], 10) : 0;
      var bestPct = bestPctMatch ? parseInt(bestPctMatch[1], 10) : 0;

      if (currentPct > bestPct || (currentPct === bestPct && currentThreshold >= bestThreshold)) {
        bestDiscountMarker = marker;
      }
    });

    if (bestDiscountMarker) {
      var code = (bestDiscountMarker.dataset.discountCode || '').trim();
      if (code) {
        if (PromoBar._lastAppliedDiscount !== code) {
          PromoBar.applyDiscount(code, false, '');
        } else {
          PromoBar.updateDiscountBadgeSummary(cart);
        }
        return;
      }
    }

    PromoBar.updateDiscountBadgeSummary(cart);
    PromoBar.removeDiscount(false);
  },

  addGift: function (variantId, pendingDiscountCode, pendingDiscountMode, pendingDiscountValue) {
    if (!variantId || !String(variantId).trim()) return;
    if (PromoBar._busyGiftAdd) return;

    PromoBar._busyGiftAdd = true;
    variantId = String(variantId).trim();

    fetchCart()
      .then(function (cart) {
        var alreadyGift = (cart.items || []).some(function (item) {
          return String(item.variant_id) === variantId &&
            item.properties &&
            item.properties['_promo_gift'] === 'true';
        });

        if (alreadyGift) return null;

        return cartAdd([{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: {
            '_promo_gift': 'true',
            '_promo_gift_discount_mode': pendingDiscountMode || '',
            '_promo_gift_discount_value': String(pendingDiscountValue || 0)
          }
        }]);
      })
      .then(function () {
        return CartState.load();
      })
      .then(function (updatedCart) {
        if (!updatedCart) return null;

        CartState.cart = updatedCart;
        CartRenderer.renderSilent(updatedCart);

        if (pendingDiscountCode) {
          PromoBar._lastAppliedDiscount = '';
          return PromoBar.applyDiscount(pendingDiscountCode, true, '');
        }

        PromoBar.updateDiscountBadgeSummary(updatedCart);
        return updatedCart;
      })
      .catch(function (err) {
        console.error('[PcozCart] Falha ao adicionar brinde:', err, 'variantId:', variantId);
      })
      .finally(function () {
        PromoBar._busyGiftAdd = false;
      });
  },

  removeSpecificGift: function (variantId, cart) {
    if (!variantId || !String(variantId).trim()) return;

    variantId = String(variantId).trim();

    if (PromoBar._busyGiftRemove.has(variantId)) return;
    PromoBar._busyGiftRemove.add(variantId);

    var updates = {};

    (cart.items || []).forEach(function (item) {
      var isGift = item.properties && item.properties['_promo_gift'] === 'true';
      if (String(item.variant_id) === variantId && isGift) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      PromoBar._busyGiftRemove.delete(variantId);
      return;
    }

    cartUpdate(updates)
      .then(function () {
        return CartState.load();
      })
      .then(function (updatedCart) {
        PromoBar._busyGiftRemove.delete(variantId);
        CartState.cart = updatedCart;
        CartRenderer.renderSilent(updatedCart);
        PromoBar.updateDiscountBadgeSummary(updatedCart);
      })
      .catch(function (err) {
        PromoBar._busyGiftRemove.delete(variantId);
        console.error('[PcozCart] Falha ao remover brinde específico:', err);
      });
  },

  removeAllGifts: function (cart) {
    var updates = {};

    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties['_promo_gift'] === 'true') {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) return Promise.resolve(cart);

    return cartUpdate(updates)
      .then(function () {
        return CartState.load();
      })
      .then(function (updatedCart) {
        CartState.cart = updatedCart;
        CartRenderer.renderSilent(updatedCart);
        PromoBar.updateDiscountBadgeSummary(updatedCart);
        return updatedCart;
      })
      .catch(function (err) {
        console.error('[PcozCart] Falha ao remover brindes:', err);
        return cart;
      });
  }
};

/* ─────────────────────────────────────────────────────────────
COUPON
───────────────────────────────────────────────────────────── */

var Coupon = {
  init: function () {
    var accordion = $('#PcozCouponAccordion');
    var trigger = accordion ? $('.pcz-cart__accordion-trigger', accordion) : null;
    var body = accordion ? $('.pcz-cart__accordion-body', accordion) : null;
    var btn = $('#PcozCouponBtn');
    var input = $('#PcozCouponInput');

    if (trigger && body) {
      trigger.addEventListener('click', function () {
        accordion.classList.toggle('is-open');
      });
    }

    if (btn && input) {
      btn.addEventListener('click', function () {
        Coupon.apply(input.value);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          Coupon.apply(input.value);
        }
      });
    }
  },

  apply: function (code) {
    code = (code || '').trim();
    var msg = $('#PcozCouponMsg');
    if (!code) {
      if (msg) msg.textContent = 'Digite um código.';
      return;
    }

    if (msg) msg.textContent = 'Aplicando...';

    PromoBar.applyDiscount(code, true, '')
      .then(function () {
        if (msg) msg.textContent = 'Cupom aplicado com sucesso.';
        var accordion = $('#PcozCouponAccordion');
        if (accordion) accordion.classList.add('is-applied');
      })
      .catch(function () {
        if (msg) msg.textContent = 'Não foi possível aplicar este cupom.';
      });
  }
};

/* ─────────────────────────────────────────────────────────────
GLOBAL EVENTS
───────────────────────────────────────────────────────────── */

function bindGlobalEvents() {
  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('#PcozCartClear');
    if (clearBtn) {
      e.preventDefault();
      CartActions.clearCart();
    }
  });

  document.addEventListener('cart:refresh', function () {
    CartState.load().then(function (cart) {
      CartRenderer.render(cart);
    });
  });
}

/* ─────────────────────────────────────────────────────────────
INTERCEPT ADD-TO-CART
───────────────────────────────────────────────────────────── */

var VariantCompareCache = {};

function fetchVariantCompareData(variantId) {
  variantId = String(variantId || '').trim();
  if (!variantId) return Promise.resolve(null);

  if (VariantCompareCache[variantId]) {
    return VariantCompareCache[variantId];
  }

  VariantCompareCache[variantId] = fetch('/variants/' + encodeURIComponent(variantId) + '.js?_=' + Date.now(), {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(function (r) {
      if (!r.ok) return null;
      return r.json();
    })
    .then(function (variant) {
      if (!variant) return null;

      var price = Number(variant.price || 0);
      var compareAt = Number(variant.compare_at_price || 0);

      if (!isFinite(price)) price = 0;
      if (!isFinite(compareAt)) compareAt = 0;

      return {
        id: variant.id || variantId,
        price: price,
        compareAt: compareAt,
        discountPercent: compareAt > price && price > 0
          ? Math.round(((compareAt - price) / compareAt) * 100)
          : 0
      };
    })
    .catch(function (err) {
      console.warn('[PcozCart] Não foi possível buscar compare_at_price da variante:', variantId, err);
      return null;
    });

  return VariantCompareCache[variantId];
}

function getCartPropertiesFromFormData(fd) {
  var properties = {};

  fd.forEach(function (value, key) {
    var match = String(key || '').match(/^properties\[(.+)\]$/);
    if (!match) return;

    var propName = match[1];
    if (!propName) return;

    if (value == null || String(value).trim() === '') return;
    properties[propName] = String(value);
  });

  return properties;
}

function buildAddToCartItemFromForm(form) {
  var fd = new FormData(form);
  var id = fd.get('id');
  var qty = parseInt(fd.get('quantity'), 10) || 1;

  if (!id) return Promise.resolve(null);

  var item = {
    id: parseInt(id, 10),
    quantity: qty,
    properties: getCartPropertiesFromFormData(fd)
  };

  var sellingPlan = fd.get('selling_plan');
  if (sellingPlan && String(sellingPlan).trim()) {
    item.selling_plan = String(sellingPlan).trim();
  }

  return fetchVariantCompareData(id).then(function (variantData) {
    if (
      variantData &&
      variantData.compareAt > variantData.price &&
      variantData.discountPercent > 0
    ) {
      if (!item.properties._product_compare_price) {
        item.properties._product_compare_price = String(Math.round(variantData.compareAt));
      }

      if (!item.properties._product_compare_discount) {
        item.properties._product_compare_discount = String(variantData.discountPercent);
      }
    }

    return item;
  });
}

function addFormProductToCart(form, errorLabel) {
  if (!form || form._pczAddInProgress) return;

  form._pczAddInProgress = true;
  CartRenderer.setLoading(true);

  var multiItems = null;
  try { multiItems = form.dataset.pczItems ? JSON.parse(form.dataset.pczItems) : null; } catch (e) { multiItems = null; }

  (multiItems && multiItems.length ? Promise.resolve(multiItems) : buildAddToCartItemFromForm(form))
    .then(function (item) {
      if (Array.isArray(item)) return cartAdd(item);
      if (!item || !item.id) return null;
      return cartAdd([item]);
    })
    .then(function () {
      return CartState.load();
    })
    .then(function (cart) {
      if (!cart) return;
      CartState.cart = cart;
      CartRenderer.render(cart);
      Drawer.open();
    })
    .catch(function (err) {
      console.error('[PcozCart] ' + (errorLabel || 'Erro ao interceptar add-to-cart') + ':', err);
    })
    .finally(function () {
      form._pczAddInProgress = false;
      CartRenderer.setLoading(false);
    });
}

function bindAddToCartForms() {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    if (form.closest('#PcozCartDrawer')) return;

    e.preventDefault();
    addFormProductToCart(form, 'Erro ao interceptar add-to-cart');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="add"], .product-form__submit, .add-to-cart, .btn-add-to-cart');
    if (!btn) return;

    var form = btn.closest('form[action*="/cart/add"]');
    if (!form || form.closest('#PcozCartDrawer')) return;

    if (btn.tagName === 'BUTTON' || btn.type === 'submit') {
      return;
    }

    e.preventDefault();
    addFormProductToCart(form, 'Erro ao interceptar botão add-to-cart');
  });
}

/* ─────────────────────────────────────────────────────────────
UPSELL MODULE
───────────────────────────────────────────────────────────── */

var UpsellModule = {
  _currentIndex: 0,
  _cards: [],

  init: function () {},

  _getContainer: function () {
    return $('#PcozUpsell');
  },

  evaluate: function (cart) {
    var container = this._getContainer();
    if (!container) return;

    var currentVariantIds = (cart.items || []).map(function (item) {
      return String(item.variant_id);
    });

    var upsellVariantIds = [];

    (cart.items || []).forEach(function (item) {
      var map = window.__pcz_upsell_map || {};
      var found = map[String(item.variant_id)] || [];
      found.forEach(function (variantId) {
        if (upsellVariantIds.indexOf(String(variantId)) === -1 &&
            currentVariantIds.indexOf(String(variantId)) === -1) {
          upsellVariantIds.push(String(variantId));
        }
      });
    });

    if (!upsellVariantIds.length) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }

    container.style.display = '';

    var self = this;
    Promise.all(upsellVariantIds.map(function (variantId) {
      return self._fetchVariant(variantId);
    })).then(function (variants) {
      variants = variants.filter(Boolean);
      if (!variants.length) {
        container.innerHTML = '';
        container.style.display = 'none';
        return;
      }
      self._render(variants);
    });
  },

  _fetchVariant: function (variantId) {
    var handle = this._getHandleForVariant(variantId);

    if (handle) {
      return fetch('/products/' + handle + '.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return null;

          var variant = null;
          if (product.variants) {
            for (var i = 0; i < product.variants.length; i++) {
              if (String(product.variants[i].id) === String(variantId)) {
                variant = product.variants[i];
                break;
              }
            }
          }
          if (!variant) variant = { id: variantId, price: 0, available: true, name: product.title, title: product.title };
          if (!variant.available) return null;

          var imgSrc = '';
          if (variant.featured_image && variant.featured_image.src) {
            imgSrc = String(variant.featured_image.src);
          } else if (product.images && product.images.length > 0) {
            imgSrc = String(product.images[0]);
          }

          if (imgSrc) {
            imgSrc = imgSrc
              .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048)(?=\.(jpg|jpeg|png|gif|webp))/i, '')
              .replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '$1?width=120');
          }

          variant._product_image = imgSrc;
          variant._product_title = product.title;
          if (!variant.name) variant.name = product.title;

          return variant;
        })
        .catch(function (err) {
          console.error('[PcozUpsell] erro ao buscar produto:', handle, err);
          return null;
        });
    }

    return fetch('/variants/' + variantId + '.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (variant) {
        if (!variant || !variant.available) return null;
        var src = variant.featured_image && variant.featured_image.src ? String(variant.featured_image.src) : '';
        if (src) {
          src = src
            .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048)(?=\.(jpg|jpeg|png|gif|webp))/i, '')
            .replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '$1?width=120');
        }
        variant._product_image = src;
        return variant;
      })
      .catch(function () { return null; });
  },

  _getHandleForVariant: function (variantId) {
    var handles = window.__pcz_upsell_handles || {};
    return handles[String(variantId)] || null;
  },

  _render: function (variants) {
    var container = this._getContainer();
    if (!container) return;

    var headerText = container.dataset.upsellHeaderText || 'Leve junto com';
    var headerBold = container.dataset.upsellHeaderBold || '10% OFF';
    var headerColor = container.dataset.upsellHeaderColor || '#F63D1C';
    var btnColor = container.dataset.upsellBtnColor || '#1E4D40';

    this._currentIndex = 0;
    this._cards = variants;

    var hasMultiple = variants.length > 1;
    var trackClass = 'pcz-upsell__track' + (hasMultiple ? ' pcz-upsell__track--carousel' : ' pcz-upsell__track--single');

    var cardsHtml = variants.map(function (v, idx) {
      var imgSrc = v._product_image || '';

      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + (v.name || '') + '" loading="lazy" width="64" height="64">'
        : '<div style="width:64px;height:64px;background:#f0f0f0;border-radius:8px;"></div>';

      var price = moneyBRL(v.price);
      var title = v.name || v.title || '';

      return '<div class="pcz-upsell__card" data-variant-id="' + v.id + '" data-index="' + idx + '">' +
        '<div class="pcz-upsell__card-header" style="background:' + headerColor + ';">' +
          '<span class="pcz-upsell__card-header-text">' + headerText + ' </span>' +
          '<span class="pcz-upsell__card-header-bold">' + headerBold + '</span>' +
        '</div>' +
        '<div class="pcz-upsell__card-body">' +
          '<div class="pcz-upsell__card-img-wrap">' + imgHtml + '</div>' +
          '<div class="pcz-upsell__card-info">' +
            '<div class="pcz-upsell__card-title">' + title + '</div>' +
            '<div class="pcz-upsell__card-price">' + price + '</div>' +
          '</div>' +
          '<button class="pcz-upsell__card-btn" type="button"' +
            ' data-variant-id="' + v.id + '"' +
            ' style="background:' + btnColor + ';"' +
            ' aria-label="Adicionar ' + title + ' ao carrinho">' +
            'Adicionar ao carrinho' +
          '</button>' +
        '</div>' +
      '</div>';
    }).join('');

    var prevBtn = hasMultiple
      ? '<button class="pcz-upsell__arrow pcz-upsell__arrow--prev" aria-label="Anterior">' +
          '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>' +
        '</button>'
      : '';

    var nextBtn = hasMultiple
      ? '<button class="pcz-upsell__arrow pcz-upsell__arrow--next" aria-label="Próximo">' +
          '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</button>'
      : '';

    var dotsHtml = hasMultiple
      ? '<div class="pcz-upsell__nav">' +
          variants.map(function (_, idx) {
            return '<button class="pcz-upsell__dot' + (idx === 0 ? ' is-active' : '') + '"' +
              ' data-index="' + idx + '" aria-label="Ir para card ' + (idx + 1) + '"></button>';
          }).join('') +
        '</div>'
      : '';

    container.innerHTML =
      '<div class="pcz-upsell__track-outer">' +
        prevBtn +
        '<div class="' + trackClass + '" id="PcozUpsellTrack">' +
          cardsHtml +
        '</div>' +
        nextBtn +
      '</div>' +
      dotsHtml;

    this._bindEvents(container, btnColor);
  },

  _bindEvents: function (container, btnColor) {
    var self = this;
    var track = $('#PcozUpsellTrack', container);
    var dots = $$('.pcz-upsell__dot', container);

    function goTo(idx) {
      var cards = $$('.pcz-upsell__card', track);
      if (!cards.length) return;
      idx = Math.max(0, Math.min(idx, cards.length - 1));
      self._currentIndex = idx;
      var offset = idx * (cards[0].offsetWidth + 12);
      track.style.transform = 'translateX(-' + offset + 'px)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
      });
    });

    var prevBtn = $('.pcz-upsell__arrow--prev', container);
    var nextBtn = $('.pcz-upsell__arrow--next', container);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(self._currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(self._currentIndex + 1);
      });
    }

    var touchStartX = 0;
    if (track) {
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          goTo(self._currentIndex + (diff > 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    $$('.pcz-upsell__card-btn', container).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = 'Adicionando...';

        cartAdd([{
          id: variantId,
          quantity: 1,
          properties: { _upsell: 'true' }
        }])
          .then(function () {
            return CartState.load();
          })
          .then(function (cart) {
            CartState.cart = cart;
            CartRenderer.render(cart);
            UpsellModule.evaluate(cart);
          })
          .catch(function (err) {
            console.error('[PcozCart] Upsell add error:', err);
            btn.disabled = false;
            btn.textContent = 'Adicionar ao carrinho';
            btn.style.background = btnColor;
          });
      });
    });
  }
};

/* ─────────────────────────────────────────────────────────────
INIT
───────────────────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function () {
  var styleId = 'pcz-ineligible-style';
  if (!document.getElementById(styleId)) {
    var s = document.createElement('style');
    s.id = styleId;
    s.textContent = [
      '.pcz-cart__promo-message--ineligible {',
      '  background: #fff8e1;',
      '  border: 1px solid #f5c518;',
      '  border-radius: 8px;',
      '  padding: 8px 12px;',
      '  margin-bottom: 4px;',
      '}',
      '.pcz-cart__promo-ineligible {',
      '  color: #7a5800;',
      '  font-size: 13px;',
      '  line-height: 1.4;',
      '  display: block;',
      '}'
    ].join('\n');
    document.head.appendChild(s);
  }

  Drawer.init();
  Drawer.neutralizeThemeDrawer();
  Coupon.init();
  UpsellModule.init();
  bindGlobalEvents();
  bindAddToCartForms();

  CartState.load().then(function (cart) {
    CartRenderer.renderSilent(cart);
    PromoBar.evaluate(cart);
  }).catch(function (err) {
    console.error('[PcozCart] Falha ao inicializar carrinho:', err);
  });
});

})();